export const getCanvasInitialConfig = () => ({
    zoom: {
        multiplier: 0.1,
        start: 1,
        max: 20,
        min: 0.5,
    },
    grid: {
        size: 5,
        multiplier: 2,
        deskHeight: 4,
        gapBetweenDeskAndSeats: 2,
        seatWidth: 4,
        seatHeight: 4,
        seatGap: 1,
        seatPadding: 0.25,
        indicatorDiameter: 0.8,
        flagWidth: 2,
        flagHeight: 2,
    },
    canvas: {
        backgroundColor: '#fff',
        preserveObjectStacking: true,
    },
});
